import { render, staticRenderFns } from "./file-preview.generic.vue?vue&type=template&id=2099124e&"
import script from "./file-preview.generic.vue?vue&type=script&lang=js&"
export * from "./file-preview.generic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports